import React from "react";
import MyLogo from '../Assets/logo.svg';

const Home = () => {
  return (
    <div
      style={{
        minHeight: "calc(100vh - 60px)",
        background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center", 
        padding: "0",
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: "18px",
          boxShadow: "0 8px 32px 0 rgba(31, 38, 135, 0.12)",
          padding: "48px 40px",
          maxWidth: "480px",
          width: "100%",
          textAlign: "center",
        }}
      >
        <img
          src="/logo192.png"
          alt="Pre Sale Project Logo"
          style={{
            width: 80,
            height: 80,
            marginBottom: 24,
            borderRadius: "50%",
            boxShadow: "0 2px 8px rgba(63,48,255,0.10)",
            background: "#f5f7fa",
          }}
        />
        <h1
          style={{
            fontSize: "2.2rem",
            fontWeight: 700,
            color: "#232946",
            marginBottom: 12,
            letterSpacing: "0.5px",
          }}
        >
          Welcome to Pre Sale Project Admin Panel
        </h1>
        <p
          style={{
            fontSize: "1.1rem",
            color: "#555",
            marginBottom: 28,
            lineHeight: 1.6,
          }}
        >
          Manage your opportunities, estimates, contracts, and more with a modern, intuitive dashboard.
        </p>
        <div style={{ marginTop: 24 }}>
          <a
            href="/dashboard"
            style={{
              display: "inline-block",
              padding: "12px 32px",
              background: "linear-gradient(90deg, #3F30FF 0%, #6C63FF 100%)",
              color: "#fff",
              borderRadius: "8px",
              fontWeight: 600,
              fontSize: "1rem",
              textDecoration: "none",
              boxShadow: "0 2px 8px rgba(63,48,255,0.10)",
              transition: "background 0.2s",
            }}
          >
            Go to Dashboard
          </a>
        </div>
      </div>
    </div>
  );
};

export default Home;